import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5150544f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-inline-flex flex-row px-1 fw-normal text-link" }
const _hoisted_2 = ["href"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "chev" }, " ›", -1))
const _hoisted_4 = { key: 1 }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { class: "chev" }, " ›", -1))

import router from "@/router";

interface Props {
  text?: string;
  link?: string;
  color?: string;
  traditionalLink: boolean;
  onclick?: () => void;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    text: { default: "Button" },
    link: { default: "" },
    color: { default: "#17620f" },
    traditionalLink: { type: Boolean },
    onclick: { type: Function, default: undefined }
  },
  emits: ["onClick"],
  setup(__props: any, { emit }: { emit: ({
  (e: "onClick", event: MouseEvent): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { text: string, link: string, color: string, traditionalLink: boolean, onclick: () => void }

_useCssVars(_ctx => ({
  "64c23732": (props.color)
}))





function clickPrevent(event: MouseEvent) {
  if (props.onclick) {
    props.onclick();
  } else if (props.link.startsWith("http")) {
    window.location.href = props.link;
  } else if (props.link.startsWith("mailto")) {
    window.location.href = props.link;
  } else {
    router.push(props.link);
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (props.traditionalLink)
      ? (_openBlock(), _createElementBlock("a", {
          key: 0,
          href: props.link,
          class: "pr-1"
        }, [
          _createTextVNode(_toDisplayString(__props.text) + " ", 1),
          _hoisted_3
        ], 8, _hoisted_2))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("a", {
            class: "pr-1",
            onClick: _withModifiers(clickPrevent, ["prevent"])
          }, _toDisplayString(__props.text), 9, _hoisted_5),
          _hoisted_6
        ]))
  ]))
}
}

})